import React, { createContext, useState, useContext, ReactNode } from "react";

const SearchResultContext = createContext<any>({});

export const useColumnWidths = () => {
  return useContext(SearchResultContext);
};

export const SearchResultProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [columnWidths, setColumnWidths] = useState<any>({});

  const setWidth = (key: string, width: number, defaultWidth: number) => {
    setColumnWidths((prevWidths: any) => ({
      ...prevWidths,
      [key]: Math.max(defaultWidth, width),
    }));
  };

  const resetWidth = () => {
    setColumnWidths({});
  };

  return (
    <SearchResultContext.Provider
      value={{ columnWidths, setWidth, resetWidth }}
    >
      {children}
    </SearchResultContext.Provider>
  );
};
